var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38609 0.946615C0.866094 1.46661 0.866094 2.30661 1.38609 2.82661L6.55943 7.99995L1.38609 13.1733C0.866094 13.6933 0.866094 14.5333 1.38609 15.0533C1.90609 15.5733 2.74609 15.5733 3.26609 15.0533L9.38609 8.93328C9.90609 8.41328 9.90609 7.57328 9.38609 7.05328L3.26609 0.933281C2.75943 0.426614 1.90609 0.426615 1.38609 0.946615Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.64440860e5bab9979b68bfe65e98a6a3.svg";
export { ForwardRef as ReactComponent };